module.exports = __webpack_public_path__ + "static/media/user2.ee2b8cfc.png";